import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class CommonHelperService {

  constructor(private snackBar: MatSnackBar, private router: Router) { }

  downLoadFile(data: any, type: string, filename: string) {
    let blob = new Blob([data], { type: type });
    let downloadURL = window.URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = downloadURL;
    link.download = filename;
    link.click();
  }

  openSnackBar(message: any, panel: string) {
    this.snackBar.open(message, "", {
      duration: 3000,
      panelClass: [panel],
      verticalPosition: "top",
    });
  }
  closeSnackBar(message: any, panel: string) {
    this.snackBar.open(message, "X", {
      duration: Infinity,
      panelClass: [panel],
      verticalPosition: "top",
    });
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event) => {
        // console.log("navigation started,closing snackbar",event);
        this.snackBar.dismiss();
      });
  }

  closeSnackbarOnRouteChange() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event) => {
        // console.log("navigation started,closing snackbar",event);
        this.snackBar.dismiss();
      });
  }


  formatDate(date: string) {
    return new Date(date).toLocaleString('en-US', { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "numeric", second: "numeric" });
  }

}